export class EmailRendererTestResult {
    public client: string;
    public id: string;
    public screenshot: string;
    public thumbnail: string;

    constructor(emailRendererResult?: EmailRendererTestResult) {
        this.client = emailRendererResult && emailRendererResult.client || null;
        this.id = emailRendererResult && emailRendererResult.id || null;
        this.screenshot = emailRendererResult && emailRendererResult.screenshot || null;
        this.thumbnail = emailRendererResult && emailRendererResult.thumbnail || null;
    }
}
